function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { useTranslation } from 'react-i18next';
import { SideMenu } from '@keen.io/ui-core';
import { HeadingSettingsContainer, Layout, Section, SideMenuWrapper } from './App.styles';
import HeadingSettings from '../HeadingSettings';
import AxesTitles, { AXES_TITLES_WIDGETS } from '../AxesTitles';
import { MENU_ITEMS, MENU_ITEMS_ENUM } from '../../constants';
import ComponentSettings from '../ComponentSettings/ComponentSettings';
import FormatSettings from '../FormatSettings/FormatSettings';

var App = function App(_ref) {
  var chart = _ref.chart,
      widget = _ref.widget,
      widgetType = _ref.widgetType,
      savedQueryName = _ref.savedQueryName,
      onUpdateChartSettings = _ref.onUpdateChartSettings,
      onUpdateWidgetSettings = _ref.onUpdateWidgetSettings,
      customizationSections = _ref.customizationSections,
      onMenuItemChange = _ref.onMenuItemChange,
      activeMenuItem = _ref.activeMenuItem,
      analysisResult = _ref.analysisResult;

  var _useTranslation = useTranslation(),
      t = _useTranslation.t;

  var headingSettings = customizationSections.headingSettings,
      formatValues = customizationSections.formatValues,
      componentSettings = customizationSections.componentSettings;
  var title = widget.title,
      subtitle = widget.subtitle;
  var formatValue = chart.formatValue;
  var TranslatedMenuItems = MENU_ITEMS.map(function (_ref2) {
    var id = _ref2.id,
        label = _ref2.label;
    return {
      id: id,
      label: t(label)
    };
  });

  var onMenuChange = function onMenuChange(itemId) {
    onMenuItemChange && onMenuItemChange(itemId);
  };

  return React.createElement(Layout, null, React.createElement(SideMenuWrapper, null, React.createElement(SideMenu, {
    menuItems: TranslatedMenuItems,
    onChange: onMenuChange,
    activeItemId: activeMenuItem
  })), activeMenuItem === MENU_ITEMS_ENUM.TITLES && React.createElement(Section, null, React.createElement(HeadingSettingsContainer, null, React.createElement(HeadingSettings, {
    title: title,
    subtitle: subtitle,
    savedQueryName: savedQueryName,
    settingsDisabled: headingSettings === null || headingSettings === void 0 ? void 0 : headingSettings.isDisabled,
    onUpdateTitleSettings: function onUpdateTitleSettings(settings) {
      return onUpdateWidgetSettings(_objectSpread(_objectSpread({}, widget), {}, {
        title: settings
      }));
    },
    onUpdateSubtitleSettings: function onUpdateSubtitleSettings(settings) {
      return onUpdateWidgetSettings(_objectSpread(_objectSpread({}, widget), {}, {
        subtitle: settings
      }));
    }
  }), AXES_TITLES_WIDGETS.includes(widgetType) && React.createElement(AxesTitles, {
    settingsDisabled: headingSettings === null || headingSettings === void 0 ? void 0 : headingSettings.isDisabled,
    xAxisTitle: chart.xAxisTitle,
    yAxisTitle: chart.yAxisTitle,
    onUpdateAxesTitles: function onUpdateAxesTitles(axesTitles) {
      return onUpdateChartSettings(_objectSpread(_objectSpread({}, chart), axesTitles));
    }
  }))), activeMenuItem === MENU_ITEMS_ENUM.FORMATTING && React.createElement(Section, null, React.createElement(FormatSettings, {
    widgetType: widgetType,
    chartSettings: chart,
    formattingDisabled: formatValues === null || formatValues === void 0 ? void 0 : formatValues.isDisabled,
    formattingNotAvailable: formatValues === null || formatValues === void 0 ? void 0 : formatValues.isNotAvailable,
    formatValue: formatValue,
    onUpdateColumnNamesMapping: function onUpdateColumnNamesMapping(columns) {
      onUpdateChartSettings(_objectSpread(_objectSpread({}, chart), columns));
    },
    onUpdateFormatValue: function onUpdateFormatValue(formatSettings) {
      onUpdateChartSettings(_objectSpread(_objectSpread({}, chart), formatSettings));
    }
  })), activeMenuItem === MENU_ITEMS_ENUM.CHART_ELEMENTS && React.createElement(Section, null, React.createElement(ComponentSettings, {
    widgetType: widgetType,
    chartSettings: chart,
    widgetSettings: widget,
    onUpdateWidgetSettings: onUpdateWidgetSettings,
    onUpdateChartSettings: onUpdateChartSettings,
    componentSettingsConfig: componentSettings,
    analysisResult: analysisResult
  })));
};

export default App;